<!--MobileHeader:页眉 2021/12/20 11:18:33 YuAng-->

<template>
  <div class="ho-mobile-header">
    <van-tabs ref="tabs" @change="onClick" line-height="0" title-active-color="#2695FF">
      <van-tab v-for="(item,index) in navigators" :key="'li' + index" :title="item.title" :name="item.id">
        <template v-if="item.children" #title>
          <van-popover v-model="item.showPopover" trigger="click" :actions="item.children" @select="onSelect" :get-container="getContainer">
            <template #reference>
              <span type="primary">{{item.title}} </span>
              <van-icon :name="item.showPopover ? 'arrow-up' : 'arrow-down'" />
            </template>
          </van-popover>
        </template>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
export default {
  name: 'MobileHeader',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      navigators: [
        { id: '1', title: '首页', url: '/eclass/mobile/home', pcUrl: '/' },
        {
          id: '2',
          title: '产品介绍',
          defaultTitle: '产品介绍',
          showPopover: false,
          children: [
            { id: '2-1', text: '学校教学方案', url: '/eclass/mobile/school', className: '', pcUrl: '/eclass/school' },
            { id: '2-2', text: '区域教育方案', url: '/eclass/mobile/area', className: '', pcUrl: '/eclass/area' }
          ]
        },
        { id: '7', title: '试用申请', url: '/eclass/mobile/apply', pcUrl: '/apply/submit' }
      ],
      currentTab: '1',
      navigator: null
    }
  },
  created() {
    let target = null
    for (let index = 0; index < this.navigators.length; index++) {
      const item = this.navigators[index];
      if (item.children) {
        const child = item.children.find(item => location.pathname.indexOf(item.url) >= 0)
        if (child) {
          target = child
          break
        }
      } else if (location.pathname.indexOf(item.url) >= 0) {
        target = item
        break
      }
    }
    if (target) {
      if (window.screen.width < 1000) {
        this.navigator = target
      } else {
        const url = '/official' + target.pcUrl
        window.open(url, '_self')
        setTimeout(() => {
          location.reload()
        }, 1);
      }
    }
  },
  mounted() {
    if (this.navigator) {
      if (this.navigator.id.indexOf('-') >= 0) {
        this.onSelect(this.navigator)
      } else {
        this.$refs.tabs.scrollTo(this.navigator.id)
      }
    }
  },
  methods: {
    onClick: function (navId) {
      // 让所有二级菜单一级导航重置到默认显示
      for (let index = 0; index < this.navigators.length; index++) {
        const item = this.navigators[index];
        if (item.children && item.id !== navId) {
          item.title = item.defaultTitle
          for (let index = 0; index < item.children.length; index++) {
            const child = item.children[index];
            child.className = ''
          }
        }
      }
      const target = this.navigators.find(item => item.id === navId)
      if (target && !target.children) {
        this.currentTab = target.id
        document.body.scrollTop = 0 // 回到顶部1
        document.documentElement.scrollTop = 0 // 回到顶部2
        this.$router.push(target.url)
      } else if (navId !== this.currentTab) {
        // 点开了二级菜单，没有选中的二级菜单，让tab恢复到原来的tab位置
        this.$refs.tabs.scrollTo(this.currentTab)
      }
    },
    onSelect: function (item) {
      const pId = item.id.split('-')[0]
      const target = this.navigators.find(item => item.id === pId)
      target.title = item.text
      for (let index = 0; index < target.children.length; index++) {
        const child = target.children[index];
        child.className = ''
      }
      item.className = 'active'
      this.currentTab = pId
      // 点击了二级菜单后，才定位到其父级所在tab
      this.$refs.tabs.scrollTo(this.currentTab)
      document.body.scrollTop = 0 // 回到顶部1
      document.documentElement.scrollTop = 0 // 回到顶部2
      this.$router.push(item.url)
    },
    getContainer: function () {
      return this.$el;
    }
  }
}
</script>

<style scoped>
.ho-mobile-header {
  position: fixed;
  width: 100%;
  z-index: 2;
}
.ho-mobile-header >>> .van-tabs--line .van-tabs__wrap {
  height: 53px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
}

.ho-mobile-header >>> .van-popover__action.active {
  color: #2695ff;
}
</style>